<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <p class="hint">{{ hint }}</p>

  <!-- §3b decision 2 — the Netcare booking form and the VeriClaim day list serve different
       audiences, so the user picks. Rendered only for the theatre-list export. -->
  <div class="document-options" *ngIf="asksForDocumentType">
    <mat-radio-group [(ngModel)]="selectedDocumentType" class="document-radio-group">
      <mat-radio-button *ngFor="let documentType of documentTypes" [value]="documentType.value"
        class="document-option">
        <span class="document-option-label">{{ documentType.label }}</span>
        <span class="document-option-hint" *ngIf="documentType.hint">{{ documentType.hint }}</span>
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="filter-options" (click)="$event.stopPropagation()">
    <div *ngFor="let appointmentType of appointmentTypes" class="filter-option">
      <mat-checkbox [(ngModel)]="appointmentType.selected" (click)="$event.stopPropagation()">
        <div class="filter-option-content">
          <span class="appointment-type-preview"
            [ngStyle]="{
              'background-color': appointmentType.backgroundColor || '#e0e0e0',
              'color': appointmentType.textColor || '#000',
              'border': appointmentType.borderColor ? '2px solid ' + appointmentType.borderColor : 'none'
            }">
          </span>
          <span>{{ appointmentType.type }}</span>
        </div>
      </mat-checkbox>
    </div>
  </div>
  <div class="select-actions">
    <button mat-button (click)="selectAll()">Select all</button>
    <button mat-button (click)="deselectAll()">Deselect all</button>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="export()" [disabled]="!canExport">
    Export
  </button>
</mat-dialog-actions>
